import { tmpl } from '@/utils/util-extent';
import CompareUtil from '@/components/module/CompareUtil';

const { $ } = window;

export default class CompareStepSelect {
  constructor(carList, excludetest) {
    this.carList = carList;
    this.excludetest = excludetest;
    this.isInit = false;
    this.selectedCars = [];
    this.init();

    this.nullSelectObj = { ID: null, TITLE2: '' };
    this.$head = $('#compare-table-head');
    this.$specs = $('#compare-table-container');
    this.carDropdownHtml = $('#template-car-dropdown').html();
    this.carShowHtml = $('#template-car-show').html();
    this.defaultCarView = '<button class="car-selector-btn select-car-button"><span class="text">+選擇車款</span></button></div>';
    this.specCategory = $('#template-spec-category').html();
    this.specItem = $('#template-spec-item').html();

    this.onLoadChange();
  }

  static checkLargeViewSize() {
    return window.innerWidth >= 1024;
  }

  // 檢查是否有參數輸入
  onLoadChange() {
    const maxSelectCarLength = CompareStepSelect.checkLargeViewSize() ? 3 : 2;
    const addrData = CompareUtil.parseAddress();
    console.log(addrData);
    if (addrData.page === 'result') {
      const checkedItem = $('input[name="selectCar"]');
      for (let index = 0; index < addrData.cars.length; index += 1) {
        const carurl = addrData.cars[index];
        checkedItem.each((i, element) => {
          if ($(element).data('namurl') === carurl) {
            $(element).attr('checked', 'checked');
            const car = this.carList.find((item) => item.TITLE2 === carurl);
            this.selectedCars.push(car);
          }
        });
      }
      for (let index = 0; this.selectedCars.length < maxSelectCarLength && index < maxSelectCarLength; index += 1) {
        this.selectedCars.push(this.nullSelectObj);
      }
      $('[data-fancybox-confirm-select]').attr('disabled', false);
      $('#sectionSelectCar').hide();
      $('#sectionCompareTable').show();
      this.updateCarView(addrData);
    }
  }

  // 初始化事件
  init() {
    const self = this;
    const idcar = '#compareHeadrow';
    const idEngine = '#compareEngine';
    const idLevel = '#compareLevel';
    this.initCarOptions();
    // 開始比較
    $('[data-fancybox-confirm-select]').on('click', (event) => {
      event.preventDefault();
      self.onSubmitClick();
    });
    // 引擎下拉事件
    $(idEngine).on('click', 'a.dropdown-item', function click(event) {
      event.preventDefault();
      const active = 'active';
      $(this).removeClass(active);
      $(this).siblings().removeClass(active);
      $(this).addClass(active);

      const id = $(this).closest('.dropdown-menu').attr('aria-labelledby');
      $(`${idEngine} #${id}`).text($(this).text());
      const eng = $(this).data('eng');
      const selectindex = $(this).data('selectindex');

      self.updateEngine(eng, selectindex);
    });
    // 等級下拉事件
    $(idLevel).on('click', 'a.dropdown-item', function click(event) {
      event.preventDefault();
      const active = 'active';
      $(this).removeClass(active);
      $(this).siblings().removeClass(active);
      $(this).addClass(active);

      const id = $(this).closest('.dropdown-menu').attr('aria-labelledby');
      $(`${idLevel} #${id}`).text($(this).text());
      const modelsno = $(this).data('modelsno');
      const selectindex = $(this).data('selectindex');
      const eng = $(`${idEngine} .compare-content-col-carid_${selectindex + 1} [data-selectindex].active`).data('eng');

      self.updateType(eng, modelsno, selectindex);
    });
    // 刪除目前比較顯示車款
    $(idcar).on('click', '.close-btn', function click(event) {
      event.preventDefault();
      const indexObj = $(this).attr('data-remove-compare');
      const index = parseInt(indexObj, Number) - 1;
      const car = self.selectedCars[index];
      self.selectedCars[index] = self.nullSelectObj;
      // 同車款刪除時，要檢查全部刪除才清除checkbox
      if (!self.selectedCars.some((element) => element.ID === car.ID)) {
        $(`#selectCarModal .row input[value=${car.ID}]`).prop('checked', false);
      }
      const addrData = CompareUtil.parseAddress();
      addrData.cars[index] = '';
      addrData.engs[index] = '';
      addrData.types[index] = '';
      self.updateCarView(addrData);
    });
    // this.$target.find('.submit-btn').on('click', this.onSubmitClick.bind(this));
  }

  // 初始化車款選項 搭配 script 動態取得html
  initCarOptions() {
    const $container = $('.select-car-list-wrap .row');
    const html = $('#template-car-option').html();
    let data;
    let $option;
    for (let index = 0; index < this.carList.length; index += 1) {
      const item = this.carList[index];
      let tag = '';
      if (item.HOT === '1') {
        tag = '<span class="tag">New!</span>';
      }
      data = {
        SNO: item.ID, // carsno
        CARNAME: item.TITLE, // carnam
        NAMURL: item.TITLE2, // nam_url
        IMAGE: item.IMAGE, // img
        tagNew: tag,
        COUNT: item.COUNT,
        MODELSNOS: item.MODELSNOS,
        ENGSSTR: item.ENGSSTR,
        DISPLAY: item.COUNT === '1' ? "style='display:none'" : '',
        CARNMS: item.CARNMS,
      };
      $option = tmpl(html, data);
      $container.append($option);
    }
  }

  // 加入比對車款(後續改為選位置放入車款)
  onSubmitClick() {
    const maxSelectCarLength = CompareStepSelect.checkLargeViewSize() ? 3 : 2;
    const self = this;
    const checkedItemSnos = $('input[name="selectCar"]:checked').map((_idx, elem) => $(elem).val()).get();
    // 判斷是否保留目前車款 方法
    let addrData = CompareUtil.parseAddress();
    console.log(addrData);
    if (addrData.page === 'result' && checkedItemSnos.length > 1) {
      const checkedItems = $('input[name="selectCar"]:checked');
      // 檢查是否有重選車款狀況
      self.selectedCars.forEach((e, index) => {
        if ($(`input[data-namurl="${e.TITLE2}"]:checked`).length === 0) {
          addrData.cars[index] = '';
          addrData.engs[index] = '';
          addrData.types[index] = '';
          self.selectedCars[index] = self.nullSelectObj;
        }
      });
      // 判斷新的車款加入
      const funPushCar = (index) => {
        checkedItems.each((_i, element) => {
          const carurl = $(element).data('namurl');
          if (!self.selectedCars.some((e) => e.TITLE2 === carurl)) {
            self.selectedCars[index] = this.carList.find((item) => item.TITLE2 === carurl);
          }
        });
      };
      // 處理新車款加入
      for (let index = 0; index < this.selectedCars.length; index += 1) {
        const selectCar = this.selectedCars[index];
        if (selectCar === self.nullSelectObj) {
          funPushCar(index);
        }
      }

      this.updateCarView(addrData);
      return;
    }
    // 直接進入網頁 方法
    this.selectedCars = [];
    for (let index = 0; index < checkedItemSnos.length; index += 1) {
      const sno = checkedItemSnos[index];
      const car = this.carList.find((item) => item.ID === sno);
      if (car !== undefined) {
        this.selectedCars.push(car);
      }
    }
    addrData = null;
    if (this.selectedCars.length === 1) { // 如果只選一台車 幫他做出另外兩台同樣的車子不同等級或引擎搭配的
      const car = this.selectedCars[0];// 先取出選中的那台
      const eng = car.ENGS; // 取得引擎的資料
      let count = 0;
      addrData = { engs: [], types: [] };
      eng.forEach((engData) => {
        engData.TYPES.forEach((item) => {
          if (count < maxSelectCarLength) {
            addrData.engs.push(engData.ENG);
            addrData.types.push(item.ID);
            if (count !== 0) {
              // let newCar={...car,defaultENG:engData,defaultTYP:item};
              this.selectedCars.push(car);
            }
            count += 1;
          }
        });
      });
    }
    if (this.selectedCars.length < maxSelectCarLength) {
      this.selectedCars.push(this.nullSelectObj);
    }
    this.updateCarView(addrData);
  }

  // 更新車款、引擎、等級、建議售價
  updateCarView(addrData = null) {
    for (let index = 0; index < this.selectedCars.length; index += 1) {
      const car = this.selectedCars[index];
      const indexObj = index + 1;
      const $carShow = this.$head.find(`#compareHeadrow .compare-content-col-carid_${indexObj}`);
      $carShow.empty();
      const $carEngine = this.$head.find(`#compareEngine .compare-content-col-carid_${indexObj}`);
      $carEngine.empty();
      const $carLevel = this.$head.find(`#compareLevel .compare-content-col-carid_${indexObj}`);
      $carLevel.empty();
      const $carPrice = this.$head.find(`#comparePrice .compare-content-col-carid_${indexObj}`);
      $carPrice.empty();
      if (car.ID != null) {
        // 車款
        const carShowItem = tmpl(this.carShowHtml, {
          INDEXOBJ: indexObj,
          NAME: car.TITLE,
          IMG: car.IMAGE,
        });
        $carShow.append(carShowItem);
        // 引擎 預設選擇第一筆 或網路參數
        let engIndex1 = car.ENGS[0];
        let carEngineOptionsHtml = '';
        let firstActiveTag = '';
        for (let j = 0; j < car.ENGS.length; j += 1) {
          const engItem = car.ENGS[j];
          firstActiveTag = '';
          if (addrData != null && addrData.engs[index] !== '') {
            if (engItem.ENG.toString() === addrData.engs[index].toString()) {
              engIndex1 = engItem;
              firstActiveTag = 'active';
            }
          } else if (j === 0) {
            firstActiveTag = 'active';
          }
          carEngineOptionsHtml += `<a class="dropdown-item ${firstActiveTag}" href="#" data-selectindex="${index}" data-eng="${engItem.ENG}">${engItem.ENGNAM}</a>`;
        }

        const carEngineItem = tmpl(this.carDropdownHtml, {
          INDEXOBJ: indexObj,
          SELECTVALUE: engIndex1.ENGNAM,
          OPTIONS: carEngineOptionsHtml,
        });
        $carEngine.append(carEngineItem);
        // 等級 預設選擇第一筆 或網路參數
        let carLevelOptionsHtml = '';
        let typeIndex1 = engIndex1.TYPES[0];
        for (let j = 0; j < engIndex1.TYPES.length; j += 1) {
          const typeItem = engIndex1.TYPES[j];
          firstActiveTag = '';
          if (addrData != null && addrData.types[index] !== '') {
            if (typeItem.ID.toString() === addrData.types[index].toString()) {
              typeIndex1 = typeItem;
              firstActiveTag = 'active';
            }
          } else if (j === 0) {
            firstActiveTag = 'active';
          }
          carLevelOptionsHtml += `<a class="dropdown-item ${firstActiveTag}" href="#" data-selectindex="${index}" data-modelsno="${typeItem.ID}">${typeItem.TITLE}</a>`;
        }

        const carTypeItem = tmpl(this.carDropdownHtml, {
          INDEXOBJ: indexObj,
          SELECTVALUE: typeIndex1.TITLE,
          OPTIONS: carLevelOptionsHtml,
        });
        $carLevel.append(carTypeItem);
        // 價錢
        $carPrice.append(`${typeIndex1.PRICE} 萬`);
      } else {
        $carShow.append(this.defaultCarView);
        $carEngine.append('-');
        $carLevel.append('-');
        $carPrice.append('-');
      }
    }

    this.updateList();
  }

  // 更新引擎下拉選單
  updateEngine(eng, selectindex) {
    const indexObj = selectindex + 1;
    const car = this.selectedCars[selectindex];
    const engItem = car.ENGS.find((e) => e.ENG.toString() === eng.toString());
    const $carLevel = this.$head.find(`#compareLevel .compare-content-col-carid_${indexObj}`);
    $carLevel.empty();
    const $carPrice = this.$head.find(`#comparePrice .compare-content-col-carid_${indexObj}`);
    $carPrice.empty();
    // 等級
    let carLevelOptionsHtml = '';
    let firstActiveTag = 'active';
    for (let j = 0; j < engItem.TYPES.length; j += 1) {
      const typeItem = engItem.TYPES[j];
      if (j !== 0) firstActiveTag = '';
      carLevelOptionsHtml += `<a class="dropdown-item ${firstActiveTag}" href="#" data-selectindex="${selectindex}" data-modelsno="${typeItem.ID}">${typeItem.TITLE}</a>`;
    }
    const typeIndex1 = engItem.TYPES[0];
    const carTypeItem = tmpl(this.carDropdownHtml, {
      INDEXOBJ: indexObj,
      SELECTVALUE: typeIndex1.TITLE,
      OPTIONS: carLevelOptionsHtml,
    });
    $carLevel.append(carTypeItem);
    // 價錢
    $carPrice.append(`${typeIndex1.PRICE} 萬`);

    this.updateList();
  }

  // 更新等級下拉選單
  updateType(eng, modelsno, selectindex) {
    const indexObj = selectindex + 1;
    const car = this.selectedCars[selectindex];
    const engItem = car.ENGS.find((e) => e.ENG.toString() === eng.toString());
    const typeItem = engItem.TYPES.find((e) => e.ID.toString() === modelsno.toString());

    const $carPrice = this.$head.find(`#comparePrice .compare-content-col-carid_${indexObj}`);
    $carPrice.empty();
    // 價錢
    $carPrice.append(`${typeItem.PRICE} 萬`);

    this.updateList();
  }

  // 更新前置動作
  updateList() {
    const cars = [];
    const types = [];
    const engs = [];
    for (let index = 0; index < this.selectedCars.length; index += 1) {
      const indexObj = index + 1;
      const car = this.selectedCars[index];
      cars.push(car.TITLE2);
      const type = this.$head.find(`#compareLevel .compare-content-col-carid_${indexObj} .active`).data('modelsno');
      types.push(type);
      const eng = this.$head.find(`#compareEngine .compare-content-col-carid_${indexObj} [data-selectindex].active`).data('eng');
      engs.push(eng);
      this.updateItemTestDrive(car.TITLE2, indexObj);
    }
    CompareUtil.setAddress('result', cars, types, engs, true);
    this.loadList(cars, types);
  }

  // 取得車款比較資料
  loadList(cars, types) {
    $.ajax({
      url: 'api/compare.ashx',
      type: 'POST',
      dataType: 'json',
      cache: 'false',
      data: {
        CARS: cars.join(','),
        TYPES: decodeURIComponent(types.join(',')),
      },
    })
      .done((e) => {
        if (e.RS === 'OK') {
          this.onLoadList(e.DATA);
        } else {
          console.log(e.RS);
        }
      })
      .fail((e) => {
        console.log('error', e);
      })
      .always(() => {
        // console.log('complete');
      });
  }

  // 建置顯示物件html
  onLoadList(data) {
    this.$specs.empty();

    let rows = '';
    let category;
    let categoryHtml;
    let item;
    for (let i = 0; i < data.SPECS.length; i += 1) {
      category = data.SPECS[i];
      rows = '';
      for (let j = 0; j < category.DATA.length; j += 1) {
        item = category.DATA[j];
        let val1; let val2; let val3;
        if (item.DATA1 === 'Y') {
          val1 = '●';
        } else if (item.DATA1 !== '') {
          val1 = item.DATA1;
        } else {
          val1 = '-';
        }
        if (item.DATA2 === 'Y') {
          val2 = '●';
        } else if (item.DATA2 !== '') {
          val2 = item.DATA2;
        } else {
          val2 = '-';
        }
        if (item.DATA3 === 'Y') {
          val3 = '●';
        } else if (item.DATA3 !== '') {
          val3 = item.DATA3;
        } else {
          val3 = '-';
        }
        rows += tmpl(this.specItem, {
          TITLE: item.TITLE,
          VALUE1: val1,
          VALUE2: val2,
          VALUE3: val3,
        });
      }
      categoryHtml = tmpl(this.specCategory, {
        CATEGORYID: `category${i}`,
        TITLE: category.CATEGORY,
        ROWS: rows,
      });
      this.$specs.append(categoryHtml);
    }
  }

  // 更新試乘資訊
  updateItemTestDrive(carName, indexObj) {
    const btn = $(`#compare-footer .compare-content-col-carid_${indexObj} a`);
    btn.attr('href', `testdrive.aspx#/${carName}`);
    const isShow = this.excludetest.indexOf(carName) < 0 && carName !== '';
    btn.toggle(isShow);

    // onclick: 'gaev("btn", "click", "btn_compare_td{CAR}")'.replace(/{CAR}/g, carData.TITLE),
  }
}
